import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UIModule, UIRangeComponent } from '@bannerflow/ui';
import { ExpandablePromptInputType } from '@studio/domain/components/ai-studio.types';
import { GenAIService } from '../../state/gen-ai.service';
import { ExpandablePromptComponent } from '../expandable-prompt/expandable-prompt.component';

@Component({
    imports: [UIModule, UIRangeComponent, ExpandablePromptComponent],
    selector: 'style-options',
    templateUrl: './style-options.component.html',
    styleUrls: ['./style-options.component.scss']
})
export class StyleOptionsComponent {
    private genAiService = inject(GenAIService);

    prompt = signal('');
    negativePrompt = signal('');
    showNegativePrompt = false;
    isRequestingStyle = toSignal(this.genAiService.isRequestingStyle$, { initialValue: false });
    actionsDisabled = computed(() => !this.prompt() || this.isRequestingStyle());

    controlStrength = 7;

    ExpandablePromptInputType = ExpandablePromptInputType;

    onPromptChange(newValue: string): void {
        this.prompt.set(newValue);
    }

    onNegativePromptChange(newValue: string): void {
        this.negativePrompt.set(newValue);
    }

    adjustControlStrength(newValue: number): void {
        this.controlStrength = newValue;
    }

    style(): void {
        this.genAiService.style(this.prompt(), this.controlStrength, this.negativePrompt());
    }
}
